import React, { useState, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useToast } from '../../../Utils/toastContext';
import Dropdown from '../../../Components/CustomDropdown/customdropdown';
import ConfirmContinueButton from '../../../Components/ContinueButton/continue-button';
import ConfirmResetButton from '../../../Components/ContinueButton/reset-button';
import { useNavigate } from 'react-router-dom';
import DocumentPreview from '../../Create-Investment/documentpreview';
import {
  setStepStatus,
  setRejectedFields,
} from '../../../Redux/store/onboardingFormSlice';
import LabelWithStatus from '../../../Components/onboarding/label-with-status';
import { clearFileIdsRedux } from '../../../Redux/store/userSlice';
import ReviewPopup from '../../../Components/onboarding/review-popup';
import CustomDropdownWithFetch from '../../../Components/CustomDropdown/custom-dropdown-fetchAPI';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
const AgentUploadProof = ({ setCurrentStep }) => {
  const updateFieldStatus = useSelector(
    (state) => state.user.updateFieldStatus,
  );
  const userStatus = useSelector((state) => state.user.userStatus);
  const stepStatus = useSelector((state) => state.form.stepStatus);
  const [preselectedCountryCode, setpreselectedCountryCode] = useState({});
  const rejectedFields = useSelector((state) => state.form.rejectedFields);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const BASE_URL = process.env.REACT_APP_BASE_URL;
  const [loading, setLoading] = useState(false);
  const { showToast } = useToast();
  const [showPopup, setShowPopup] = useState(false);
  const [currentField, setCurrentField] = useState({});
  const [currentFieldName, setCurrentFieldName] = useState('');
  const [currentFieldValue, setCurrentFieldValue] = useState('');
  const [currentFieldType, setCurrentFieldType] = useState('');
  const [countryCodeData, setCountryCodeData] = useState([]);
  const [stateId, setStateId] = useState({
    verification_id: null,
    value: {
      id: 1,
      name: '',
    },
    status: 'pending',
    rejection_reason: null,
    rejection_comment: null,
    rejection_timestamp: null,
    rejected_by: null,
    comments: [],
  });
  const fieldLabelMap = {
    document_expiry: 'Expiry Date',
    front_file: "Copy of Driver's License (Front)",
    back_file: "Copy of Driver's License (Front)",
    document_number: 'Document Number',
    country_of_issue_id: 'Country where issued',
    state_of_issue: 'State or Territory in Australia',
  };
  const [preselectedStateType, setPreselectedStateType] = useState({});
  const [expiryDate, setExpiryDate] = useState({
    verification_id: null,
    value: '',
    status: 'pending',
    rejection_reason: null,
    rejection_comment: null,
    rejection_timestamp: null,
    rejected_by: null,
    comments: [],
  });

  const [documentNumber, setDocumentNumber] = useState({
    verification_id: null,
    value: '',
    status: 'pending',
    rejection_reason: null,
    rejection_comment: null,
    rejection_timestamp: null,
    rejected_by: null,
    comments: [],
  });

  const [stateData, setStateData] = useState([]);
  const driverLicenseFrontRef = useRef(null);
  const driverLicenseBackRef = useRef(null);
  const [fileDriverLinsenceFront, setFileDriverLinsenceFront] = useState({
    verification_id: null,
    value: null,
    status: 'pending',
    rejection_reason: null,
    rejection_comment: null,
    rejection_timestamp: null,
    rejected_by: null,
    comments: [],
  });
  const [fileDriverLinsenceBack, setFileDriverLinsenceBack] = useState({
    verification_id: null,
    value: null,
    status: 'pending',
    rejection_reason: null,
    rejection_comment: null,
    rejection_timestamp: null,
    rejected_by: null,
    comments: [],
  });

  const [countryCode, setCountryCode] = useState({
    verification_id: null,
    value: {
      id: 14,
      name: 'Australia',
      risk_factor: 'low',
    },
    status: 'pending',
    rejection_reason: null,
    rejection_comment: null,
    rejection_timestamp: null,
    rejected_by: null,
    comments: [],
  });

  const [currentDocument, setcurrentDocument] = useState({});
  const [isModalOpen, setIsModalOpen] = useState(false);
  const getCountries = async (page, searchTerm) => {
    try {
      // Backend should support pagination & search
      const size = 10; // fetch 50 cities per page
      const response = await GetAPIcalls(
        `/api/v1/users/countries?page=${page}&size=${size}&search=${
          searchTerm || ''
        }`,
      );

      if (response.status === 200) {
        const items = response.data.countries.map((item) => ({
          value: item.id,
          label: item.name,
          risk_factor: item.risk_factor,
        }));

        return {
          items,
          hasMore: response.data.countries.length === size, // if less than size, no more data
        };
      } else {
        if (response.status === 401) {
          localStorage.removeItem('jwtToken');
          navigate('/login');
        }
        return { items: [], hasMore: false };
      }
    } catch (err) {
      showToast(err.message, 'error');
      return { items: [], hasMore: false };
    }
  };
  const getStates = async () => {
    try {
      const response = await GetAPIcalls(`/api/v1/users/states/14`);

      if (response.status === 200) {
        const statelistData = [];
        response.data.states.forEach((profile) => {
          statelistData.push({
            value: profile.id,
            label: profile.name,
          });
        });
        setStateData(statelistData);
      } else {
        if (response.status === 401) {
          localStorage.removeItem('jwtToken');
          navigate('/login');
        }
        return { items: [], hasMore: false };
      }
    } catch (err) {
      showToast(err.message, 'error');
      setStateData([]);
    }
  };
  const handleSelectStateData = (selectedOption) => {
    console.log('Selected Option:', selectedOption.value);
    setStateId({
      ...stateId,
      value: {
        id: selectedOption.value,
        name: selectedOption.label,
      },
    });
  };
  useEffect(() => {
    if (expiryDate.value && typeof expiryDate.value === 'string') {
      setExpiryDate({
        ...expiryDate,
        value: new Date(expiryDate.value), // convert string to Date
      });
    }
  }, [expiryDate.value]);
  const formatDate = (date) => {
    if (!date) return '';

    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');

    return `${year}-${month}-${day}`;
  };
  const getCurrentDate = () => {
    const today = new Date();
    today.setMinutes(today.getMinutes() - today.getTimezoneOffset()); // Adjust for timezone
    return today.toISOString().split('T')[0]; // Get YYYY-MM-DD format
  };
  const checkFileNameExist = (selectedFile) => {
    if (
      (fileDriverLinsenceFront.value &&
        fileDriverLinsenceFront.value.file_name.toLowerCase() ===
          selectedFile.name.toLowerCase()) ||
      (fileDriverLinsenceBack.value &&
        fileDriverLinsenceBack.value.file_name.toLowerCase() ===
          selectedFile.name.toLowerCase())
    ) {
      return true;
    } else {
      return false;
    }
  };
  const handleStatusClick = (docData, fieldText, fieldValue, fieldType) => {
    setCurrentField(docData);
    setCurrentFieldName(fieldText);
    setCurrentFieldValue(fieldValue);
    setCurrentFieldType(fieldType);
    dispatch(clearFileIdsRedux());
    setShowPopup(true);
  };
  const fileUploadNew = async (file) => {
    const token = localStorage.getItem('jwtToken');
    const headers = {};

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    const apiUrl = `${BASE_URL}/api/v1/files/upload`;
    const formData3 = new FormData();
    formData3.append('file', file); // Append file
    try {
      const response = await fetch(apiUrl, {
        method: 'POST',
        headers,
        body: formData3,
      });
      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem('jwtToken');
          navigate('/login');
          throw new Error('Session expired. Please log in again.');
        }
        const errorData = await response.json().catch(() => ({
          message: 'An unexpected error occurred',
        }));
        throw new Error(errorData.message || 'Something went wrong');
      }
      return await response.json();
    } catch (error) {
      console.error('API Call Error:', error); // Log full error for debugging
      throw new Error(
        typeof error.message === 'string'
          ? error.message
          : 'Network error, please try again later',
      );
    }
  };
  const handleFileClick = (e, rowData) => {
    setcurrentDocument(rowData);
    setIsModalOpen(true);
  };
  const handleFileChangeDriverLincenseFront = async (e) => {
    const selectedFile = e.target.files[0];
    let toastMessage = null;
    if (selectedFile) {
      const fileType = selectedFile.type;
      const fileSize = selectedFile.size;
      if (checkFileNameExist(selectedFile)) {
        if (driverLicenseFrontRef.current) {
          driverLicenseFrontRef.current.value = null;
        }
        showToast(
          'Please upload the required document; one file with the same name has already been uploaded..',
          'error',
        );
        return;
      }
      if (
        ['application/pdf', 'image/png', 'image/jpeg'].includes(fileType) &&
        fileSize <= 10 * 1024 * 1024
      ) {
        setLoading(true);
        try {
          const response = await fileUploadNew(selectedFile);
          if (response.status == 201) {
            setFileDriverLinsenceFront({
              ...fileDriverLinsenceFront,
              value: response.data,
            });
          } else {
            toastMessage = { message: response.message, type: 'error' };
          }
        } catch (err) {
          setFileDriverLinsenceFront({
            verification_id: null,
            value: null,
            status: 'pending',
            rejection_reason: null,
            rejection_comment: null,
            rejection_timestamp: null,
            rejected_by: null,
            comments: [],
          });
          toastMessage = { message: err.message, type: 'error' };
        } finally {
          setLoading(false); // Ensure `loading` is false first
          // Show toast after loading is false
          if (toastMessage) {
            setTimeout(() => {
              showToast(toastMessage.message, toastMessage.type);
            }, 300); // Small delay if needed
          }
        }
      } else {
        showToast(
          'File must be PDF, PNG, or JPEG and less than 10MB.',
          'error',
        );
      }
    }
    e.target.value = '';
  };

  const handleDeleteDriverLinsenceFront = () => {
    setFileDriverLinsenceFront({
      verification_id: null,
      value: null,
      status: 'pending',
      rejection_reason: null,
      rejection_comment: null,
      rejection_timestamp: null,
      rejected_by: null,
      comments: [],
    });
    if (driverLicenseFrontRef && driverLicenseFrontRef.current) {
      driverLicenseFrontRef.current.value = null;
    }
  };

  const handleSelectCountryCode = (selectedOption) => {
    setCountryCode({
      ...countryCode,
      value: {
        id: selectedOption.value,
        name: selectedOption.label,
        risk_factor: selectedOption.risk_factor,
      },
    });
  };
  const handleFileChangeDriverLincenseBack = async (e) => {
    const selectedFile = e.target.files[0];
    let toastMessage = null;
    if (selectedFile) {
      const fileType = selectedFile.type;
      const fileSize = selectedFile.size;
      if (checkFileNameExist(selectedFile)) {
        if (driverLicenseBackRef.current) {
          driverLicenseBackRef.current.value = null;
        }
        showToast(
          'Please upload the required document; one file with the same name has already been uploaded..',
          'error',
        );
        return;
      }
      if (
        ['application/pdf', 'image/png', 'image/jpeg'].includes(fileType) &&
        fileSize <= 10 * 1024 * 1024
      ) {
        setLoading(true);
        try {
          const response = await fileUploadNew(selectedFile);
          if (response.status == 201) {
            setFileDriverLinsenceBack({
              ...fileDriverLinsenceBack,
              value: response.data,
            });
          } else {
            toastMessage = { message: response.message, type: 'error' };
          }
        } catch (err) {
          setFileDriverLinsenceBack({
            verification_id: null,
            value: null,
            status: 'pending',
            rejection_reason: null,
            rejection_comment: null,
            rejection_timestamp: null,
            rejected_by: null,
            comments: [],
          });
          toastMessage = { message: err.message, type: 'error' };
        } finally {
          setLoading(false); // Ensure `loading` is false first
          // Show toast after loading is false
          if (toastMessage) {
            setTimeout(() => {
              showToast(toastMessage.message, toastMessage.type);
            }, 300); // Small delay if needed
          }
        }
      } else {
        showToast(
          'File must be PDF, PNG, or JPEG and less than 10MB.',
          'error',
        );
      }
    }
    e.target.value = '';
  };
  const handleDeleteDriverLinsenceBack = () => {
    setFileDriverLinsenceBack({
      verification_id: null,
      value: null,
      status: 'pending',
      rejection_reason: null,
      rejection_comment: null,
      rejection_timestamp: null,
      rejected_by: null,
      comments: [],
    });
    if (driverLicenseBackRef && driverLicenseBackRef.current) {
      driverLicenseBackRef.current.value = null;
    }
  };
  const handleContinue = (isFinal) => {
    if (isFinal) {
      if (!countryCode.value.id) {
        showToast('Please select document issuing country.', 'error');
        return;
      }
      if (countryCode.value.id == 14 && !stateId?.value?.id) {
        showToast('Please select Australian state.', 'error');
        return;
      }

      if (!fileDriverLinsenceFront.value) {
        showToast(
          'Please upload the front side of your driver’s license.',
          'error',
        );
        return;
      }
      if (!fileDriverLinsenceBack.value) {
        showToast(
          'Please upload the back side of your driver’s license.',
          'error',
        );
        return;
      }
      if (!expiryDate.value) {
        showToast('Please add the document expiry date.', 'error');
        return;
      }
      if (!documentNumber.value) {
        showToast(
          'Please enter a valid number as mentioned on the document.',
          'error',
        );
        return;
      }
    }

    setLoading(true);
    handlesave(isFinal);
  };
  const resetApplicationAPI = async () => {
    const token = localStorage.getItem('jwtToken');
    const headers = {
      'Content-Type': 'application/json',
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    let apiUrl = `${BASE_URL}/api/v1/onboarding/agent/driving-licence/reset`;
    let bodyData = {};
    try {
      const response = await fetch(apiUrl, {
        method: 'POST',
        headers: headers,
        body: JSON.stringify(bodyData),
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem('jwtToken');
          navigate('/login');
          throw new Error('Session expired. Please log in again.');
        }
        const errorData = await response.json().catch(() => ({
          message: 'An unexpected error occurred',
        }));
        throw new Error(errorData.message || 'Something went wrong');
      }

      return await response.json();
    } catch (error) {
      throw new Error(error.message || 'Network error, please try again later');
    }
  };
  const handleReset = async () => {
    let toastMessage = null;
    try {
      const response = await resetApplicationAPI();
      if (response.status == 200) {
        toastMessage = {
          message: response.message,
          type: 'success',
        };
        getDetails();
        const responseStatus = await GetAPIcalls(`/api/v1/onboarding/status`);
        if (responseStatus.status == 200) {
          if (responseStatus.data.length > 0) {
            dispatch(setStepStatus(responseStatus.data));
          }
        }
        const responseRejected = await GetAPIcalls(
          `/api/v1/onboarding/rejected-fields`,
        );
        if (responseRejected.status == 200) {
          dispatch(setRejectedFields(responseRejected.data)); // <-- Save in Redux
        }
      } else {
        toastMessage = { message: response.message, type: 'error' };
      }
    } catch (err) {
      toastMessage = { message: err.message, type: 'error' };
    } finally {
      setLoading(false); // Ensure `loading` is false first
      // Show toast after loading is false
      if (toastMessage) {
        setTimeout(() => {
          showToast(toastMessage.message, toastMessage.type);
        }, 300); // Small delay if needed
      }
    }
  };
  const handleBack = () => {
    setCurrentStep(1);
  };
  const GetAPIcalls = async (url) => {
    const token = localStorage.getItem('jwtToken');
    const apiUrl = `${BASE_URL}${url}`;
    const headers = {
      'Content-Type': 'application/json',
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }

    try {
      const response = await fetch(apiUrl, {
        method: 'GET',
        headers,
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem('jwtToken');
          navigate('/login');
          throw new Error('Session expired. Please log in again.');
        }
        const errorData = await response.json().catch(() => ({
          message: 'An unexpected error occurred',
        }));
        throw new Error(errorData.message || 'Something went wrong');
      }

      return await response.json();
    } catch (error) {
      console.error('API Call Error:', error); // Log full error for debugging
      throw new Error(
        typeof error.message === 'string'
          ? error.message
          : 'Network error, please try again later',
      );
    }
  };
  const safeValue = (val) => {
    return val === undefined || val === null || val === '' ? null : val;
  };
  const submitApplicationAPI = async (isFinal) => {
    const token = localStorage.getItem('jwtToken');
    const headers = {
      'Content-Type': 'application/json',
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    let isOnboarding = userStatus == 'onboarding' ? true : false;

    let apiUrl = isOnboarding
      ? `${BASE_URL}/api/v1/onboarding/agent/driving-licence/submit`
      : `${BASE_URL}/api/v1/onboarding/agent/driving-licence/update`;
    const buildFile = (file) => {
      if (!file?.value?.file_id || !file?.value?.file_name) return null;

      return {
        file_id: safeValue(file.value.file_id),
        file_name: safeValue(file.value.file_name),
      };
    };

    let bodyData = {
      front_file: buildFile(fileDriverLinsenceFront),
      back_file: buildFile(fileDriverLinsenceBack),

      document_expiry: safeValue(formatDate(expiryDate?.value)),
      document_number: safeValue(documentNumber?.value),

      country_of_issue_id: safeValue(countryCode?.value?.id),
      state_of_issue_id: safeValue(stateId?.value?.id),

      is_submitted: Boolean(isFinal),
    };
    try {
      const response = await fetch(apiUrl, {
        method: isOnboarding ? 'POST' : 'PUT',
        headers: headers,
        body: JSON.stringify(bodyData),
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem('jwtToken');
          navigate('/login');
          throw new Error('Session expired. Please log in again.');
        }
        const errorData = await response.json().catch(() => ({
          message: 'An unexpected error occurred',
        }));
        throw new Error(errorData.message || 'Something went wrong');
      }

      return await response.json();
    } catch (error) {
      throw new Error(error.message || 'Network error, please try again later');
    }
  };
  const handlesave = async (isFinal) => {
    let toastMessage = null;
    try {
      const response = await submitApplicationAPI(isFinal);
      if (response.status == 200) {
        if (isFinal) {
          setCurrentStep(3);
          toastMessage = {
            message: response.message,
            type: 'success',
          };
          const responseStatus = await GetAPIcalls(`/api/v1/onboarding/status`);
          if (responseStatus.status == 200) {
            if (responseStatus.data.length > 0) {
              dispatch(setStepStatus(responseStatus.data));
            }
          }
          const responseRejected = await GetAPIcalls(
            `/api/v1/onboarding/rejected-fields`,
          );
          if (responseRejected.status == 200) {
            dispatch(setRejectedFields(responseRejected.data)); // <-- Save in Redux
          }
        } else {
          toastMessage = {
            message:
              'Information has been saved successfully. Please submit to proceed further.',
            type: 'success',
          };
        }
      } else {
        toastMessage = { message: response.message, type: 'error' };
      }
    } catch (err) {
      toastMessage = { message: err.message, type: 'error' };
    } finally {
      setLoading(false); // Ensure `loading` is false first
      // Show toast after loading is false
      if (toastMessage) {
        setTimeout(() => {
          showToast(toastMessage.message, toastMessage.type);
        }, 300); // Small delay if needed
      }
    }
  };
  const getDetails = async () => {
    try {
      const response = await GetAPIcalls(
        `/api/v1/onboarding/agent/driving-licence/verification/preview`,
      );

      if (response.status == 200) {
        if (response.data) {
          setCountryCode(response.data.country_of_issue);
          setpreselectedCountryCode({
            value: response.data.country_of_issue.value.id,
            label: response.data.country_of_issue.value.name,
          });

          if (response.data.country_of_issue.value.id == 14) {
            setStateId(response.data.state_of_issue);
            setPreselectedStateType({
              value: response.data.state_of_issue?.value?.value,
              label: response.data.state_of_issue?.value?.name,
            });
          }
          setExpiryDate(response.data.document_expiry);
          setDocumentNumber(response.data.document_number);

          setFileDriverLinsenceFront(response.data.front_file);
          setFileDriverLinsenceBack(response.data.back_file);
        } else {
          setDocumentNumber({
            verification_id: null,
            value: '',
            status: 'pending',
            rejection_reason: null,
            rejection_comment: null,
            rejection_timestamp: null,
            rejected_by: null,
            comments: [],
          });
          setFileDriverLinsenceFront({
            verification_id: null,
            value: null,
            status: 'pending',
            rejection_reason: null,
            rejection_comment: null,
            rejection_timestamp: null,
            rejected_by: null,
            comments: [],
          });
          setFileDriverLinsenceBack({
            verification_id: null,
            value: null,
            status: 'pending',
            rejection_reason: null,
            rejection_comment: null,
            rejection_timestamp: null,
            rejected_by: null,
            comments: [],
          });

          setDocumentNumber({
            verification_id: null,
            value: '',
            status: 'pending',
            rejection_reason: null,
            rejection_comment: null,
            rejection_timestamp: null,
            rejected_by: null,
            comments: [],
          });
          setExpiryDate({
            verification_id: null,
            value: '',
            status: 'pending',
            rejection_reason: null,
            rejection_comment: null,
            rejection_timestamp: null,
            rejected_by: null,
            comments: [],
          });
        }
      } else {
        if (response.status === 401) {
          localStorage.removeItem('jwtToken');
          navigate('/login');
        }
      }
    } catch (err) {
      showToast(err.message, 'error');
    }
  };

  useEffect(() => {
    if (stepStatus.length > 0 && stepStatus[1].status != 'DRAFT') {
      getDetails();
    }
  }, [stepStatus]);
  useEffect(() => {
    if (
      updateFieldStatus &&
      stepStatus.length > 0 &&
      stepStatus[1].status != 'DRAFT'
    ) {
      getDetails();
    }
  }, [updateFieldStatus, stepStatus]);
  useEffect(() => {
    getStates();
  }, []);
  return (
    <div className="flex flex-col min-h-[calc(100vh-100px)] lg:min-w-[80vw] lg:max-w-[80vw]">
      <div className="flex-grow  overflow-visible">
        {loading && (
          <div className="fixed top-0 left-0 w-full h-full flex justify-center items-center bg-black bg-opacity-50 z-[999]">
            <div className="w-12 h-12 border-4 border-white border-t-transparent rounded-full animate-spin"></div>
          </div>
        )}
        {stepStatus.length > 0 &&
          (stepStatus[1].status == 'IN_REVIEW' ||
            stepStatus[1].status == 'COMPLETED') && (
            <div className="mb-2 bg-yellow-100 border-l-4 border-yellow-500 text-yellow-700 p-3 rounded-md text-sm flex items-center">
              <img
                src="/warning-circle.svg"
                alt="Info"
                className="w-4 h-4 mr-2"
              />
              <span>
                This section is{' '}
                <strong>in review by our onboarding team</strong>. You will be
                notified once the verification is complete.{' '}
              </span>
            </div>
          )}
        {stepStatus.length > 0 && stepStatus[1].status == 'APPROVED' && (
          <div className="mb-2 bg-green-100 border-l-4 border-green-500 text-green-700 p-3 rounded-md text-sm flex items-center">
            <span>
              This section has been <strong>approved</strong> by our onboarding
              team.
            </span>
          </div>
        )}
        {rejectedFields?.AGENT_DRIVING_LICENCE?.rejected_fields?.length > 0 && (
          <div className="mb-3 p-3 bg-red-50 border border-red-200 rounded-md">
            <p className="font-semibold text-red-700 mb-1">
              {rejectedFields.AGENT_DRIVING_LICENCE.rejected_fields.length === 1
                ? 'The following field requires correction:'
                : 'The following fields require correction:'}{' '}
            </p>

            <div className="flex flex-wrap gap-2">
              {rejectedFields.AGENT_DRIVING_LICENCE.rejected_fields.map(
                (field) => (
                  <span
                    key={field}
                    className="px-2 py-1 bg-red-100 text-red-700 text-xs rounded"
                  >
                    {fieldLabelMap[field] || field.replace(/_/g, ' ')}
                  </span>
                ),
              )}
            </div>
          </div>
        )}
        <>
          <div className="bg-white shadow-md rounded-md p-4">
            <div className="border-b border-colour-custom pb-2">
              <div className="flex items-center space-x-2 mb-2">
                <img src="/note-2.svg" alt="User Avatar" className="h-6 w-6" />
                <h1 className="text-xl font-medium">Upload Proof Documents</h1>
              </div>

              <ul className="space-y-2 pl-6 pr-2 text-xs font-medium text-black list-disc">
                <li>
                  Please submit all colour copies of the necessary documents.
                </li>
                <li>
                  Resubmitting the application is required if the documents are
                  not submitted in colour.
                </li>
                <li className="text-[#FF5050]">
                  If you need to adjust any information from the previous
                  section, please click on the “Reset Application” button.
                </li>
              </ul>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
              {/* first column */}
              <div className="flex flex-col pr-4 md:px-4 pt-4 sm:border-r-0 md:border-r border-gray-300">
                <div className="flex items-center justify-between">
                  <LabelWithStatus
                    id="fileDriverLinsenceFront"
                    label="Upload Copy of Driver's License (Front)"
                    required={true}
                    fieldData={fileDriverLinsenceFront}
                    handleStatusClick={handleStatusClick}
                  />
                </div>

                {/* Drag & Drop Upload Area */}
                <label className="border-2 border-dashed rounded-lg p-6 mt-2 block text-center cursor-pointer flex flex-col items-center">
                  <input
                    type="file"
                    id="fileUpload"
                    accept=".pdf,.png,.jpeg"
                    ref={driverLicenseFrontRef}
                    onChange={handleFileChangeDriverLincenseFront}
                    className="hidden"
                    disabled={
                      fileDriverLinsenceFront.status == 'approved'
                        ? true
                        : false
                    }
                  />
                  <img
                    src="/folder-add.svg"
                    alt="Success Icon"
                    className="h-4 w-4"
                  />{' '}
                  <p
                    disabled={
                      fileDriverLinsenceFront.status == 'approved'
                        ? true
                        : false
                    }
                    className="mt-2 text-gray-500 text-sm"
                  >
                    Drag & Drop <br />
                    or <span className="underline">Click to Upload</span>
                  </p>
                </label>
                <div className="mt-1">
                  <span className="mt-2 mr-2 bg-[#8E8E8E] text-white px-2 py-1 rounded-md text-xs">
                    PNG
                  </span>
                  <span className="mt-1 mr-2 bg-[#8E8E8E] text-white px-2 py-1 rounded-md text-xs">
                    JPEG
                  </span>
                  <span className="mt-1 mr-2 bg-[#8E8E8E] text-white px-2 py-1 rounded-md text-xs">
                    PDF
                  </span>
                  <span className="mt-1 mr-2 bg-[#8E8E8E] text-white px-2 py-1 rounded-md text-xs">
                    &#60; 10 MB
                  </span>
                </div>
                {fileDriverLinsenceFront && fileDriverLinsenceFront.value && (
                  <div
                    className={`${
                      fileDriverLinsenceFront.status == 'rejected'
                        ? 'border-[#FF5050] border-2'
                        : 'border'
                    }  mt-4 bg-white  shadow-md rounded-lg flex items-center justify-between px-3 py-2`}
                  >
                    <div
                      onClick={(e) => {
                        e.preventDefault();
                        handleFileClick(e, fileDriverLinsenceFront.value);
                      }}
                      className="flex-col flex "
                    >
                      <span className="text-black break-all cursor-pointer underline">
                        {fileDriverLinsenceFront.value.file_name}
                      </span>
                      <span className="text-[#46DA55] text-xs">
                        Upload Completed
                      </span>
                    </div>
                    {fileDriverLinsenceFront.status != 'approved' && (
                      <button
                        onClick={handleDeleteDriverLinsenceFront}
                        className="text-red-500 flex-shrink-0 font-semibold"
                      >
                        <img
                          src="/trash.svg"
                          alt="Success Icon"
                          className="h-4 w-4 flex-shrink-0"
                        />
                      </button>
                    )}
                  </div>
                )}
                <div className="mt-2 flex items-center justify-between">
                  <LabelWithStatus
                    id="fileDriverLinsenceBack"
                    label="Upload Copy of Driver's License (Back)"
                    required={true}
                    fieldData={fileDriverLinsenceBack}
                    handleStatusClick={handleStatusClick}
                  />
                </div>
                {/* Drag & Drop Upload Area */}
                <label className="border-2 border-dashed rounded-lg p-6 mt-2 block text-center cursor-pointer flex flex-col items-center">
                  <input
                    type="file"
                    id="fileUpload"
                    accept=".pdf,.png,.jpeg"
                    ref={driverLicenseBackRef}
                    onChange={handleFileChangeDriverLincenseBack}
                    className="hidden"
                    disabled={
                      fileDriverLinsenceBack.status == 'approved' ? true : false
                    }
                  />
                  <img
                    src="/folder-add.svg"
                    alt="Success Icon"
                    className="h-4 w-4"
                  />{' '}
                  <p
                    disabled={
                      fileDriverLinsenceBack.status == 'approved' ? true : false
                    }
                    className="mt-2 text-gray-500 text-sm"
                  >
                    Drag & Drop <br />
                    or <span className="underline">Click to Upload</span>
                  </p>
                </label>
                <div className="mt-1">
                  <span className="mt-2 mr-2 bg-[#8E8E8E] text-white px-2 py-1 rounded-md text-xs">
                    PNG
                  </span>
                  <span className="mt-1 mr-2 bg-[#8E8E8E] text-white px-2 py-1 rounded-md text-xs">
                    JPEG
                  </span>
                  <span className="mt-1 mr-2 bg-[#8E8E8E] text-white px-2 py-1 rounded-md text-xs">
                    PDF
                  </span>
                  <span className="mt-1 mr-2 bg-[#8E8E8E] text-white px-2 py-1 rounded-md text-xs">
                    &#60; 10 MB
                  </span>
                </div>
                {fileDriverLinsenceBack && fileDriverLinsenceBack.value && (
                  <div
                    className={`${
                      fileDriverLinsenceBack.status == 'rejected'
                        ? 'border-[#FF5050] border-2'
                        : 'border'
                    }  mt-4 bg-white  shadow-md rounded-lg flex items-center justify-between px-3 py-2`}
                  >
                    <div
                      onClick={(e) => {
                        e.preventDefault();
                        handleFileClick(e, fileDriverLinsenceBack.value);
                      }}
                      className="flex-col flex "
                    >
                      <span className="text-black break-all cursor-pointer underline">
                        {fileDriverLinsenceBack.value.file_name}
                      </span>
                      <span className="text-[#46DA55] text-xs">
                        Upload Completed
                      </span>
                    </div>
                    {fileDriverLinsenceBack.status != 'approved' && (
                      <button
                        onClick={handleDeleteDriverLinsenceBack}
                        className="text-red-500 flex-shrink-0 font-semibold"
                      >
                        <img
                          src="/trash.svg"
                          alt="Success Icon"
                          className="h-4 w-4 flex-shrink-0"
                        />
                      </button>
                    )}
                  </div>
                )}
              </div>
              {/* second column */}
              <div className="flex flex-col pr-4 pt-4 sm:border-r-0 md:border-r border-gray-300">
                <LabelWithStatus
                  id="documentNumber"
                  label="Driver's License Number"
                  required={true}
                  fieldData={documentNumber}
                  handleStatusClick={handleStatusClick}
                />
                <input
                  id="jAccId"
                  name="jAccId"
                  type="text"
                  value={documentNumber.value}
                  disabled={documentNumber.status == 'approved' ? true : false}
                  placeholder="Enter Number"
                  className={`${
                    documentNumber.status == 'rejected'
                      ? 'border-[#FF5050] border-2'
                      : ''
                  } rounded-lg h-[2.813rem] border dark:focus-visible:ring-[#4E4E4E] dark:text-white focus-visible:ring-1 focus-visible:ring-black text-black text-base font-medium dark:dark:bg-[#101010] dark:border-[#4F4F4F] appearance-none border w-full py-2 px-3  leading-tight focus:outline-none focus:shadow-outline`}
                  onChange={(e) =>
                    setDocumentNumber({
                      ...documentNumber,
                      value: e.target.value,
                    })
                  }
                />
                <div className="mt-4">
                  <LabelWithStatus
                    id="expiryDate"
                    label=" Expiry Date"
                    required={true}
                    fieldData={expiryDate}
                    handleStatusClick={handleStatusClick}
                  />
                  <div className="w-full">
                    <DatePicker
                      selected={expiryDate.value}
                      onChange={(date) =>
                        setExpiryDate({
                          ...expiryDate,
                          value: date,
                        })
                      }
                      disabled={expiryDate.status == 'approved' ? true : false}
                      dateFormat="dd/MM/yyyy"
                      minDate={new Date()}
                      showMonthDropdown
                      showYearDropdown
                      dropdownMode="scroll" //
                      yearDropdownItemNumber={100} // 🔥 show 100 years
                      scrollableYearDropdown // 🔥 smooth scroll
                      placeholderText="Select Expiry Date"
                      wrapperClassName="w-full"
                      className={`w-full p-2 border rounded-md ${
                        expiryDate.status == 'rejected'
                          ? 'border-red-500'
                          : 'border-gray-300'
                      }`}
                    />
                  </div>
                </div>
              </div>
              {/* third column */}
              <div className="flex flex-col pr-4 pt-4">
                <div className="">
                  <LabelWithStatus
                    id="companyLogo"
                    label={fieldLabelMap.country_of_issue_id}
                    required={true}
                    fieldData={countryCode}
                    handleStatusClick={handleStatusClick}
                  />
                  <CustomDropdownWithFetch
                    lßabel=""
                    options={countryCodeData}
                    search={true}
                    preselectedValue={preselectedCountryCode}
                    onSelect={handleSelectCountryCode}
                    colorLabel=""
                    fetchOptions={getCountries} // <-- pass fetch function, not options
                  />
                </div>
                {countryCode.value.id == 14 && (
                  <>
                    <div className="mt-4">
                      <LabelWithStatus
                        id="companyLogo"
                        label="State or Territory in Australia"
                        required={true}
                        fieldData={stateId}
                        handleStatusClick={handleStatusClick}
                      />
                      <Dropdown
                        label=""
                        options={stateData}
                        onSelect={handleSelectStateData}
                        disabled={stateId.status == 'approved'}
                        preselectedValue={preselectedStateType}
                        parentClass={
                          stateId.status == 'rejected'
                            ? 'border-[#FF5050] border-2'
                            : ''
                        }
                      />
                    </div>
                  </>
                )}
              </div>
            </div>
          </div>
          {isModalOpen && currentDocument && (
            <DocumentPreview
              fileUrl={currentDocument.presigned_url}
              fileName={currentDocument.file_name}
              onClose={() => setIsModalOpen(false)}
            />
          )}
        </>
      </div>
      {showPopup && currentField && (
        <ReviewPopup
          isOpen={showPopup}
          currentField={currentField}
          currentFieldName={currentFieldName}
          currentFieldValue={currentFieldValue}
          currentFieldType={currentFieldType}
          onClose={() => setShowPopup(false)}
        />
      )}
      <footer className="mb-1 bottom-actions flex flex-col flex-shrink-0 md:flex-row p-4 bg-[#375AE7]">
        {stepStatus.length > 0 &&
          stepStatus[1].status != 'COMPLETED' &&
          stepStatus[1].status != 'APPROVED' &&
          stepStatus[1].status != 'IN_REVIEW' && (
            <>
              <div className="flex flex-col md:flex-row items-center justify-start w-full space-y-2 md:space-y-0 relative">
                <ConfirmResetButton
                  onConfirm={handleReset}
                  isReset={true}
                  isBack={true}
                  onBack={handleBack}
                />
              </div>
              <div className="flex flex-col md:flex-row mt-2 md:mt-0 items-center justify-end w-full space-y-2 md:space-y-0 md:space-x-4 relative">
                <div className="relative w-full md:w-auto flex justify-center md:justify-end">
                  <button
                    onClick={() => {
                      handleContinue(false);
                    }}
                    className="flex w-full md:w-auto items-center justify-center space-x-2 text-white border-white border-2 font-medium py-2 px-4 rounded-full text-sm"
                  >
                    <span>Save as Draft</span>
                  </button>
                </div>
                <ConfirmContinueButton
                  onContinue={() => handleContinue(true)}
                  buttonText="Continue"
                  confirmTitle="Save Section"
                  confirmMessage="Are you sure, you want to continue. This action will ensure, the saved information is un-editable. Therefore please make sure you have provided the correct details."
                />
              </div>
            </>
          )}
        {stepStatus.length > 0 &&
          (stepStatus[1].status == 'COMPLETED' ||
            stepStatus[1].status == 'APPROVED' ||
            stepStatus[1].status == 'IN_REVIEW') && (
            <>
              <div className="flex flex-col md:flex-row items-center justify-start w-full space-y-2 md:space-y-0 relative">
                <ConfirmResetButton
                  onConfirm={handleReset}
                  isReset={false}
                  isBack={true}
                  onBack={handleBack}
                />
              </div>

              <div className="flex flex-col md:flex-row items-center justify-end w-full space-y-2 md:space-y-0 md:space-x-4 relative">
                {/* Save as Draft */}
                <button
                  onClick={() => {
                    setCurrentStep(3);
                  }}
                  className="flex w-full md:w-auto items-center justify-center space-x-2 border-2 border-white text-white font-medium py-2 px-4 rounded-full text-sm"
                >
                  <span>Next</span>
                </button>
              </div>
            </>
          )}
      </footer>
    </div>
  );
};
export default AgentUploadProof;
